import React, {useContext} from 'react'
import {Redirect, useParams, useHistory} from 'react-router-dom'
import {useAudioPlayer} from 'react-use-audio-player'
import '../css/pages/StoryPage.css'

import audioIndex from '../audio/audioIndex'
import audioTranscripts from '../audio/audioTranscripts'

import {PlayerStatsContext} from '../context/PlayerStatsContext'
import {BackgroundMusicContext} from '../context/BackgroundMusicContext'

import BrassPanel from '../components/BrassPanel'
import PaperPanel from '../components/PaperPanel'
import TextParagraphs from '../components/TextParagraphs'

function StoryPage() {
    const {playerStats} = useContext(PlayerStatsContext)
    const {fadeBackgroundAudio, playMachineBackground} = useContext(BackgroundMusicContext)
    const {locationId} = useParams()
    const route = useHistory()
    
    const locationNames = {
        office: "The Professor's Office",
        library: 'The Library',
        laboratory: 'The Laboratory',
        fourJokers: 'The Four Joker',
        lastStand: 'The Last Stand',
        machine: 'The Machine'
    }
    
    const {togglePlayPause, loading, playing} = useAudioPlayer({
        src: audioIndex.[locationId],
        format: 'mp3',
        autoplay: true,
        onplay: () => fadeBackgroundAudio('OUT'),
        onend: () => {
            if (locationId === 'machine') {
                playMachineBackground()
            } else {
                fadeBackgroundAudio('UP')
            }
            route.push(`/location/${locationId}/investigate`)
        }
    })
    
    function toggleAudio() {
        const action = playing ? 'UP' : 'OUT'
        fadeBackgroundAudio(action)
        togglePlayPause()
    }
    
    return (
        <div className="pageContainer pageContainer-story">
            <main className="main-story">
                <PaperPanel extraClasses="transcriptContainer">
                    <p><strong>LARRY:</strong><br /></p>
                    <TextParagraphs text={audioTranscripts.[locationId]} />
                </PaperPanel>
                
                <BrassPanel extraClasses="audioContainer">
                    <p className="audio_name">{locationNames.[locationId]}</p>
                    {loading ? 
                        <p>audio loading...</p> : 
                        <button 
                            className="audio_btn audio_btn-story"
                            onClick={toggleAudio}
                        >
                            {playing ? 'Pause' : 'Play'} Recording
                        </button>
                    }
                </BrassPanel>
            </main>
            
            {playerStats.[locationId] !== 'open' && <Redirect to='/map' />}
        </div>
    )
}
                        
export default StoryPage